import { render } from "./ToolBarPanel.vue?vue&type=template&id=a8225d50&scoped=true"
import script from "./ToolBarPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolBarPanel.vue?vue&type=script&setup=true&lang=js"

import "./ToolBarPanel.vue?vue&type=style&index=0&id=a8225d50&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8225d50"],['__file',"src/layouts/main-layout/components/top-menu/ToolBarPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8225d50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8225d50', __exports__)) {
    api.reload('a8225d50', __exports__)
  }
  
  module.hot.accept("./ToolBarPanel.vue?vue&type=template&id=a8225d50&scoped=true", () => {
    api.rerender('a8225d50', render)
  })

}


export default __exports__